import { useMutation, useQuery } from '@tanstack/react-query'
import {
  CreateOrderGuestDto,
  OrderPayloadModel,
  QUERY
} from '../api/OrderPageAPI.model'
import OrderPageAPI from '../api/OrderPageAPI'
import { ErrorModel } from '@/api/BaseAPI.model'
import { socketService } from '@/services/socket.service'
import { WebSocketEvent } from '@/services/webSocketEvent'

type StoreOrderDish = {
  dishId: string
  sizeId?: string
  guestNumber: number
  extraNote?: string
  toppings?: { id: string; quantity: number }[]
}

export function buildOrderPayload(
  tableIds: string[],
  dishes: StoreOrderDish[]
): OrderPayloadModel {
  const guestMap = dishes.reduce<Map<number, CreateOrderGuestDto>>(
    (acc, dish) => {
      if (!acc.has(dish.guestNumber)) {
        acc.set(dish.guestNumber, { guestNumber: dish.guestNumber, dishes: [] })
      }
      acc.get(dish.guestNumber)!.dishes.push({
        dishId: dish.dishId,
        sizeId: dish.sizeId,
        toppings: dish.toppings ?? [],
        extraNote: dish.extraNote ?? ''
      })
      return acc
    },
    new Map()
  )

  return {
    tableIds,
    guests: Array.from(guestMap.values())
  }
}

export function useOrderPageQuery() {
  const dishCategoriesList = useQuery({
    queryKey: [QUERY.DISH_CATEGORIES],
    queryFn: OrderPageAPI.getDishCategories
  }).data

  const dishesList = useQuery({
    queryKey: [QUERY.DISHES],
    queryFn: OrderPageAPI.getDishes
  }).data

  const { mutate: postOrder } = useMutation<
    OrderPayloadModel,
    ErrorModel,
    OrderPayloadModel
  >({
    mutationFn: (payload: OrderPayloadModel) => OrderPageAPI.postOrder(payload),
    onSuccess: (_, payload) => {
      payload.tableIds.forEach(tableId => {
        socketService.emit(WebSocketEvent.TABLES_UPDATE, { id: tableId })
      })
    },
    onError: () => {
      // handle error
    }
  })

  return {
    dishCategoriesList,
    dishesList,
    postOrder
  }
}
